import { z } from "zod/v4";

export const createCategorySchema = z.object({
  id: z.string(),
  name: z.string().min(1, { message: "Name is required" }),
  description: z.string().min(1, { message: "Description is required" }),
  color: z.string().min(1, { message: "Color is required" }),
});

export type CreateCategorySchemaValues = z.infer<typeof createCategorySchema>;
